import React from "react";
import { Typography, Divider } from "antd";

const { Text } = Typography;

const HeatmapLegend = ({ heatmapScale }) => {
  return (
    <div>
      <Divider />
      <Text strong style={{ marginBottom: 8, display: "block" }}>
        Heatmap Legend (Scaled to Actual Data):
      </Text>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: 8,
        }}
      >
        <div
          style={{
            width: "400px",
            height: "30px",
            background:
              "linear-gradient(to right, rgb(100, 10, 10), rgb(80, 15, 10), rgb(60, 25, 10), rgb(50, 35, 5), rgb(45, 45, 15), rgb(30, 50, 15), rgb(20, 60, 15), rgb(15, 70, 20), rgb(10, 85, 25), rgb(5, 105, 40))",
            borderRadius: 4,
            border: "1px solid #434343",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "400px",
          fontSize: 11,
        }}
      >
        <Text type="danger" strong>
          {heatmapScale.minNegative.toFixed(0)}%
        </Text>
        <Text type="warning">
          {(heatmapScale.minNegative * 0.5).toFixed(0)}%
        </Text>
        <Text style={{ color: "#faad14" }}>0%</Text>
        <Text style={{ color: "#bae637" }}>
          {(heatmapScale.maxPositive * 0.25).toFixed(0)}%
        </Text>
        <Text style={{ color: "#95de64" }}>
          {(heatmapScale.maxPositive * 0.5).toFixed(0)}%
        </Text>
        <Text style={{ color: "#52c41a" }}>
          {(heatmapScale.maxPositive * 0.75).toFixed(0)}%
        </Text>
        <Text style={{ color: "#00ff41" }} strong>
          {heatmapScale.maxPositive.toFixed(0)}%
        </Text>
      </div>
      <Text type="secondary" style={{ fontSize: 12, marginTop: 8 }}>
        <strong style={{ color: "#ff4d4f" }}>Red = Any loss or 0%</strong>{" "}
        (avoid these!). Green starts at 0.01% and scales to max (
        {heatmapScale.maxPositive.toFixed(0)}%). Neon green = extreme returns!
      </Text>
    </div>
  );
};

export default HeatmapLegend;
